/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ButtonCreate.vue?vue&type=template&id=ea450ea8"
import script from "./ButtonCreate.ts?vue&type=script&lang=ts&external"
export * from "./ButtonCreate.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports